import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
  Space,
  Form,
} from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import { labelConfig, staticConfig, apiConfig } from "../../operations.config";
import { rightAction } from "../../../../redux/actions";
import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";

const { Text } = Typography;
const columns = [
  {
    title: labelConfig.id,
    dataIndex: "id",
  },
  {
    title: labelConfig.madeOnDate,
    dataIndex: "madeOnDate",
  },
  {
    title: labelConfig.time,
    dataIndex: "time",
  },
  {
    title: labelConfig.user,
    dataIndex: "user",
  },
  {
    title: labelConfig.action,
    dataIndex: "action",
  },
  {
    title: labelConfig.entity,
    dataIndex: "entity",
  },
  {
    title: labelConfig.status,
    dataIndex: "status",
  },
];

const ManageCheckerInbox = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES

  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [checkerInboxList, setCheckerInboxList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowsKeys, setSelectedRowsKeys] = useState([]);
  const [users, setUsers] = useState([]);

  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  useEffect(() => {
    getCheckerInboxTemplate();
    getSearchTemplate();
  }, []);

  const getCheckerInboxTemplate = () => {
    setIsLoading(true);

    const params = {
      sortOrder: "DESC",
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.MakerCheckers}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        // setIsLoading(false);

        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            madeOnDate: element?.madeOnDate
              ? BOM.DateTime(element?.madeOnDate, "only-date")
              : "-",
            time: element?.madeOnDate
              ? BOM.DateTime(element?.madeOnDate, "with-seconds")
              : "-",
            user: element?.maker ? element?.maker : "-",
            action: element?.actionName ? element?.actionName : "-",
            entity: element?.entityName ? element?.entityName : "-",
            status: handleFlgStatus(element?.processingResult, {}, true),
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCheckerInboxList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        dispatch({ type: cnt.CLEAR_RIGHT_BTN });
        dispatch({ type: cnt.RIGHT_SEARCH_BTN });

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  console.log(selectedRows);
  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        sortOrder: "DESC",
      };

      let body = {
        session,
        params,
      };

      const url = `${apiConfig.MakerCheckers}`;

      BOM.FetchReqAction(body, url, (err, res) => {
        if (err) {
          reject(err);
        } else {
          // setIsLoading(false);

          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              madeOnDate: element?.madeOnDate
                ? BOM.DateTime(element?.madeOnDate, "only-date")
                : "-",
              user: element?.maker ? element?.maker : "-",
              action: element?.actionName ? element?.actionName : "-",
              entity: element?.entityName ? element?.entityName : "-",
              status: element?.processingResult
                .split(".")
                .join(" ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  const getSearchTemplate = () => {
    // setIsLoading(true);

    const params = {
      sortOrder: "DESC",
    };

    let body = {
      session,
      params,
    };

    const url = `${apiConfig.MakerCheckers}/searchtemplate`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        // setIsLoading(false);

        const objList = res;
        const appUsers = objList.appUsers;
        let tempArray = [];

        setUsers(appUsers);
        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setCheckerInboxList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        dispatch({ type: cnt.CLEAR_RIGHT_BTN });

        //STOP LOAD
        // setIsLoading(false);
      }
    });
  };

  const onSelectItemAction = (newSelectedRowsKeys, objParam) => {
    setSelectedRows(objParam);
    setSelectedRowsKeys(newSelectedRowsKeys);

    if (newSelectedRowsKeys.length === 1) {
      [
        cnt.RIGHT_DETAIL_BTN,
        cnt.RIGHT_APPROVE_BTN,
        cnt.RIGHT_REJECT_BTN,
        cnt.RIGHT_DELETE_BTN,
      ].map((item) => {
        dispatch({
          type: item,
        });
      });
    } else if (newSelectedRowsKeys.length > 1) {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      [cnt.RIGHT_DELETE_BTN, cnt.RIGHT_APPROVE_BTN, cnt.RIGHT_REJECT_BTN].map(
        (item) => {
          dispatch({
            type: item,
          });
        },
      );
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    }
  };

  const rowSelection = {
    selectedRowsKeys,
    onChange: onSelectItemAction,
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-checker-inbox", {
        state: { id: selectedRows[0].id, entity: selectedRows[0].entity },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let checkerName = selectedRows.length === 1 ? "Action " : "Actions ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "delete" };

        try {
          if (selectedRows.length === 1) {
            // Single row submission
            let body = {
              method: "DELETE",
              session,
              params,
            };

            const url = `${apiConfig.MakerCheckers}/${selectedRows[0].id}`;

            BOM.FetchReqAction(body, url, (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                getCheckerInboxTemplate();
                //STOP LOAD
                setIsLoading(false);
              } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCheckerMsg);
                getCheckerInboxTemplate();
                //STOP LOAD
                setIsLoading(false);
              }
            });
          } else {
            // Batch submission (2 or more rows)
            selectedRows.map((row) => {
              let body = {
                method: "DELETE",
                session,
                params,
              };

              const url = `${apiConfig.MakerCheckers}/${row.id}`;

              return BOM.FetchReqAction(body, url, (err, res) => {
                if (err) {
                  BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                  getCheckerInboxTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                } else {
                  BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCheckerMsg);
                  getCheckerInboxTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                }
              });
            });
          }
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      },
    );
  };

  function handleOnApprove() {
    let action = "Approve  ";
    let checkerName = selectedRows.length === 1 ? "Action " : "Actions ";
    setSelectedRowsKeys([]);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "approve" };
        console.log(selectedRows);

        try {
          if (selectedRows.length === 1) {
            // Single row submission
            let body = {
              method: "POST",
              session,
              params,
            };

            let url;

            // if (
            //   selectedRows[0]?.entity === "SECURITYMASTER" ||
            //   selectedRows[0]?.entity === "FIXED_INCOME_PRODUCT"
            // ) {
            //   url = `${apiConfig.MakerCheckersTreasury}/${selectedRows[0].id}`;
            // } else {
            //   url = `${apiConfig.MakerCheckers}/${selectedRows[0].id}`;
            // }

            switch (selectedRows[0]?.serviceName) {
              case "SECURITYMASTER":
              case "FIXED_INCOME_PRODUCT":
                url = `${apiConfig.MakerCheckersTreasury}/${selectedRows[0]?.id}`;
                break;
              case "teller":
                url = `${apiConfig.MakerCheckersTeller}/${selectedRows[0]?.id}`;
                break;
              default:
                url = `${apiConfig.MakerCheckers}/${selectedRows[0]?.id}`;
            }

            BOM.FetchReqAction(body, url, (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                getCheckerInboxTemplate();
                //STOP LOAD
                setIsLoading(false);
              } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveCheckerMsg);
                getCheckerInboxTemplate();
                //STOP LOAD
                setIsLoading(false);
              }
            });
          } else {
            // Batch submission (2 or more rows)
            selectedRows.map((row) => {
              let body = {
                method: "POST",
                session,
                params,
              };

              const url = `${apiConfig.MakerCheckers}/${row.id}`;

              return BOM.FetchReqAction(body, url, (err, res) => {
                if (err) {
                  BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                  getCheckerInboxTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                } else {
                  BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveCheckerMsg);
                  getCheckerInboxTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                }
              });
            });
          }
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      },
    );
  }

  function handleOnReject() {
    let action = "Reject ";
    let checkerName = selectedRows.length === 1 ? "Action " : "Actions ";
    setSelectedRowsKeys([]);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = {
          command: "reject",
        };

        try {
          if (selectedRows.length === 1) {
            // Single row submission
            let body = {
              method: "POST",
              session,
              params,
            };

            const url = `${apiConfig.MakerCheckers}/${selectedRows[0].id}`;

            BOM.FetchReqAction(body, url, (err, res) => {
              if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                getCheckerInboxTemplate();
                //STOP LOAD
                setIsLoading(false);
              } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectCheckerMsg);
                getCheckerInboxTemplate();
                //STOP LOAD
                setIsLoading(false);
              }
            });
          } else {
            // Batch submission (2 or more rows)
            selectedRows.map((row) => {
              let body = {
                method: "POST",
                session,
                params,
              };

              const url = `${apiConfig.MakerCheckers}/${row.id}`;

              return BOM.FetchReqAction(body, url, (err, res) => {
                if (err) {
                  BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                  getCheckerInboxTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                } else {
                  BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectCheckerMsg);
                  getCheckerInboxTemplate();
                  //STOP LOAD
                  setIsLoading(false);
                }
              });
            });
          }
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      },
    );
  }

  function handleCheckerInboxSearch() {
    const { searchBtn } = rightBtn;
    if (searchBtn.toLowerCase() === "primary") {
      navigate("/search-checker-inbox", { ofObj: selectedRows });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);

    const searchKey = users.find(
      (obj) =>
        obj?.username.toLowerCase() === formValue?.searchKey.toLowerCase(),
    )?.id;

    const params = {
      makerId: searchKey,
      exactMatch: false,
      query: formValue?.searchKey,
    };

    let body = {
      session,
      params,
    };

    // return
    BOM.FetchReqAction(body, apiConfig.MakerCheckers, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            madeOnDate: element?.madeOnDate
              ? BOM.DateTime(element?.madeOnDate, "only-date")
              : "-",
            user: element?.maker ? element?.maker : "-",
            action: element?.actionName ? element?.actionName : "-",
            entity: element?.entityName ? element?.entityName : "-",
            status: handleFlgStatus(element?.processingResult, {}, true),
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCheckerInboxList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onDelete={handleOnDelete}
      onApprove={() => handleOnApprove()}
      onReject={() => handleOnReject()}
      onSearch={handleCheckerInboxSearch}
    >
      <TopContent
        pageTitle={labelConfig.manageCheckerInbox}
        pageItems={staticConfig.manageCheckerInboxBreadcrumbItems}
      />

      {/* RENDER TABLE LIST HERE*/}
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>{labelConfig.show}</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>{labelConfig.entries}</Text>
            </div>

            <Row style={{ marginLeft: 10 }}>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact
                    style={{
                      width: "100%",
                    }}
                  >
                    <Form.Item
                      name="searchKey"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("This field "),
                        },
                      ]}
                    >
                      <Input
                        placeholder="Search by User"
                        style={{ width: 400 }}
                        allowClear
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      className="of-primaryBtnColor"
                      htmlType="submit"
                    >
                      <SearchOutlined />
                    </Button>
                  </Space.Compact>
                </Form>
              </Col>
            </Row>
            {/* <DownloadTableButtons
              downloadData={checkerInboxList}
              columns={columns}
              fileName={"Checker Inbox List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={checkerInboxList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
            scroll={{ x: 800 }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageCheckerInbox);
